import script from "./Pay.vue?vue&type=script&setup=true&lang=js"
export * from "./Pay.vue?vue&type=script&setup=true&lang=js"

import "./Pay.vue?vue&type=style&index=0&id=fbfb7d92&lang=scss&scoped=true"

import exportComponent from "/home/ecs-user/software/jenkins/workspace/smallshop-website-uat/smallshop-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbfb7d92"]])

export default __exports__